import { Component, Input, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridService } from 'src/app/shared/common-components/ag-grid/ag-grid.service';
import { RangeDatepickerComponent } from 'src/app/shared/common-components/range-datepicker/range-datepicker.component';
import { CommonFilterService } from 'src/app/shared/services/common-filter.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { CustomSelect2Component } from '../../../../shared/common-components/custom-select2/custom-select2.component';
import { StorageName } from '../../../../shared/enum/common-enum';

@Component({
  selector: 'app-payment-voucher-advanced-filter',
  templateUrl: './advanced-filter-popup.component.html',
  styleUrls: ['./advanced-filter-popup.component.scss']
})
export class PaymentVoucherAdvancedFilterComponent {
  @Input() data : any = {};
  @ViewChildren(RangeDatepickerComponent) dateRangeDatepicker: QueryList<RangeDatepickerComponent>
  storageName = StorageName;
  @ViewChild("branchDropdown") branchDropdown : CustomSelect2Component;
  selectedAccountLedgerIds   = [];
  selectedagainstVoucherTypeId = [];
  advanceFilterRequest       :any = {}
  filterAgainstDropdown:any;

  constructor
  (
  public activeModal    : NgbActiveModal,
  public renderer       : Renderer2,
  public agGridService       : AgGridService,
  public storageService       : StorageService,
  public commonFilterService       : CommonFilterService,
  
  ){
  }
  ngAfterViewInit(): void {
    this.setAlreadyAppliedData();
  }
  
  setAlreadyAppliedData() {
    var previousAppliedFilters = this.storageService.retrieve(this.data?.agGridDataModel?.filterStorageName);
    if (previousAppliedFilters != undefined) {
      this.selectedAccountLedgerIds = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "ledgerid", this.data?.getAllDropdownModel?.accountLedgerDropdown, "multiselectDropdown");
      this.advanceFilterRequest.selectedAccountLedgers = this.selectedAccountLedgerIds?.map((x) => x?.id);

      this.selectedagainstVoucherTypeId = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "againstVoucherTypeId", this.data?.getAllDropdownModel?.voucherTypeDropdown, "multiselectDropdown");
      this.advanceFilterRequest.selectedagainstVoucherType = this.selectedagainstVoucherTypeId?.map((x) => x?.id);
      this.advanceFilterRequest.branchId = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "branchId", undefined, "dropdown");
      this.branchDropdown?.setDataSource(this.data.getAllDropdownModel?.branchDropdown ,String(this.advanceFilterRequest?.branchId));
      this.advanceFilterRequest.invoiceNo = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "invoiceNo", undefined, "input");
      this.advanceFilterRequest.againstInvoiceNo = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "againstInvoiceNo", undefined, "input");

      this.advanceFilterRequest.fromDate = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "fromDate", undefined, "input");
      this.advanceFilterRequest.toDate = this.commonFilterService.getPreviousAppliedFilter(previousAppliedFilters, "toDate", undefined, "input");
      this.dateRangeDatepicker?.get(0)?.onApply(false, this.advanceFilterRequest?.fromDate, this.advanceFilterRequest?.toDate);
    }
  }

  onClickAdvancedFilter() {
    this.storageService.removeItem(this.data.agGridDataModel.filterStorageName);
    this.commonFilterService.performFilterColumnwise('ledgerid', this.advanceFilterRequest?.selectedAccountLedgers, undefined, this.data?.agGridDataModel?.filterStorageName, '');

    this.commonFilterService.performFilterColumnwise('againstVoucherTypeId', this.advanceFilterRequest?.selectedagainstVoucherType, undefined, this.data?.agGridDataModel?.filterStorageName, '');
    if (this.advanceFilterRequest?.branchId != undefined)
      this.commonFilterService.performFilterColumnwise('branchId', undefined, this.advanceFilterRequest?.branchId, this.data?.agGridDataModel?.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest?.invoiceNo != undefined)
      this.commonFilterService.performFilterColumnwise('invoiceNo', undefined, this.advanceFilterRequest?.invoiceNo, this.data?.agGridDataModel?.filterStorageName, 'textFilter');

    if (this.advanceFilterRequest?.againstInvoiceNo != undefined)
      this.commonFilterService.performFilterColumnwise('againstInvoiceNo', undefined, this.advanceFilterRequest?.againstInvoiceNo, this.data?.agGridDataModel?.filterStorageName, 'textFilter');
    
    if (this.advanceFilterRequest?.fromDate != undefined)
      this.commonFilterService.performFilterColumnwise('fromDate', undefined, this.advanceFilterRequest?.fromDate, this.data?.agGridDataModel?.filterStorageName, 'dateFilter');

    if (this.advanceFilterRequest?.toDate != undefined)
      this.commonFilterService.performFilterColumnwise('toDate', undefined, this.advanceFilterRequest?.toDate, this.data?.agGridDataModel?.filterStorageName, 'dateFilter');

    var filterData = this.commonFilterService.processFilterData(this.data?.agGridDataModel?.filterStorageName)

    this.advanceFilterRequest.filters = filterData;
    this.activeModal.close(this.advanceFilterRequest)
  }

  clearFields() {
    this.advanceFilterRequest = {};
    this.selectedAccountLedgerIds = [];
     this.selectedagainstVoucherTypeId = [];
    this.commonFilterService.setDefaultFilter(this.data?.apiRequestStorageName, this.data?.apiRequestModel, this.data?.agGridDataModel?.filterStorageName);
    this.setAlreadyAppliedData();
  }


}